









































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import User from '@/objects/user';
import ServiceAgent from '../services/serviceAgent';
import EventBus from '@/services/eventBus';

const serviceAgent = new ServiceAgent();

@Component
export default class UserSettings extends Vue {
    @Prop() user!: User;

    @Prop() logoutCallback!: Function;

    settingsDialog = false;

    removeUserSectionVisible = false;

    nameChanged = false;

    emailChanged = false;

    initialName = '';

    initialEmail = '';

    oldPassword = '';

    newPassword = '';

    formValid = false;

    nameValid = false;

    emailValid = false;

    showChangePassword = false;

    validationRules = {
        required: (v: string) => !!v || 'Field is required',
        passwordConfirm: (v: string) => this.validateConfirmPassword(v) || 'Passwords does not match',
        emailValidate: (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        passwordLength: (v: string) => v.length >= 8 || 'Password length shold be more then 8 characters',
    }

    validateConfirmPassword(password: string) {
        return this.newPassword === password;
    }

    mounted() {
        this.initialEmail = this.user.Email;
        this.initialName = this.user.Name;
    }

    get userId(): string {
        const result = this.$store.getters.userId;

        return result;
    }

    get isSignedInThroughGoogle() {
        const result = this.$store.getters.isSignedInThroughGoogle;

        return result;
    }

    get currentUserName(): string {
        const result = this.$store.getters.userName;

        return result;
    }

    get userMoviesCount(): string {
        const result = this.$store.getters.userMoviesCount;

        return result;
    }

    changeName() {
        this.saveChanges('Name');
    }

    changeEmail() {
        this.saveChanges('Email');
    }

    private saveChanges(field: string) {
        const self = this;

        if (this.user !== null) {
            serviceAgent.ChangeUserInfo(this.user).then(() => {
                EventBus.$emit('openSnackbar', { snackbarText: `${field} succesfully changed`, snackbarSuccess: true });

                self.initialName = this.user.Name;
                self.initialEmail = this.user.Email;

                this.checkFieldsChanged();
            });
        }
    }

    changeUserPassword() {
        const self = this;

        if (this.user !== null) {
            serviceAgent.ChangeUserPassword(this.user.Id, this.oldPassword, this.newPassword).then(() => {
                EventBus.$emit('openSnackbar', { snackbarText: 'Password succesfully changed', snackbarSuccess: true });

                self.showChangePassword = false;
            }).catch(() => {
                EventBus.$emit('openSnackbar', { snackbarText: 'Incorrect old Password', snackbarSuccess: false });
            });
        }
    }

    clearUserMovies() {
        const self = this;

        serviceAgent.ClearUserMovies(this.user.Id).then(() => {
            EventBus.$emit('openSnackbar', { snackbarText: 'All movies were sucessfully removed', snackbarSuccess: true });

            this.$store.dispatch('setUserMovies');
        });
    }

    deleteUser() {
        const self = this;

        serviceAgent.DeleteUser(this.user.Id).then(() => {
            EventBus.$emit('openSnackbar', { snackbarText: 'User was sucessfully deleted', snackbarSuccess: false });

            this.logoutCallback();
        });
    }

    async clicked() {
        setTimeout(() => {
            this.settingsDialog = true;
        }, 100);
    }

    checkFieldsChanged() {
        this.nameChanged = !!this.user && this.user.Name !== this.initialName;
        this.emailChanged = !!this.user && this.user.Email !== this.initialEmail;
    }

    @Watch('user.Name')
    onUserNameChanged(val: string, oldVal: string) {
        this.checkFieldsChanged();
    }

    @Watch('user.Email')
    onUserEmailChanged(val: string, oldVal: string) {
        this.checkFieldsChanged();
    }
}
